import { useEffect, useState } from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import RepresentmentStartDateField from './RepresentmentStartDateField';

export default function RepresentmentStartDateDialog({
  open, accountName, initialDate, onClose, onSave,
}: {
  open: boolean;
  accountName: string;
  initialDate: string | undefined;
  onClose: () => void;
  onSave: (date: string) => Promise<void>;
}) {
  const [value, setValue] = useState<Dayjs | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setValue(initialDate ? dayjs(initialDate) : dayjs());
      setError(null);
    }
  }, [open, initialDate]);

  const invalid = !value || !value.isValid();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Representment Start Date</DialogTitle>
      <DialogContent>
        <DialogContentText component="div" sx={{ mb: 2 }}>
          The date from which Chargemont represents disputes on <strong>{accountName}</strong>.
        </DialogContentText>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <RepresentmentStartDateField value={value} onChange={setValue} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={invalid}
          onClick={async () => {
            try {
              await onSave(value!.format('YYYY-MM-DD'));
              onClose();
            } catch (err) {
              setError(err instanceof Error ? err.message : 'Failed to save');
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
